try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');
  require('bootstrap');
} catch (e) {}

window.axios = require('axios');
window.axios.defaults.baseURL =  'https://http1c.modern-expo.info/BaseCRM/hs/WebModern'
window.axios.defaults.timeout = 60000
//window.axios.defaults.headers.common['Authorization'] = '0JDQtNC80LjQvdC40YHRgtGA0LDRgtC+0YA6UnR5dWVoZXJmZGUxOTgzMTA='
window.axios.defaults.headers.common['Cache-Control'] = 'no-cache'
window.axios.defaults.headers.post['Content-Type']    = 'application/json; charset=utf-8'

/*window.axios.defaults.baseURL = process.env.VUE_APP_SERVER_BASEURL
window.axios.defaults.timeout = process.env.VUE_APP_SERVER_TIMETOUT
// window.axios.defaults.headers.common['Authorization'] = process.env.VUE_APP_SERVER_TOKEN
window.axios.defaults.headers.common['Cache-Control'] = 'no-cache'
window.axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'*/


// WEBPACK FOOTER //
// ./src/bootstrap.js